import { Injectable, EventEmitter } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { Sucursal } from "../models/Sucursal";
import { UserModel } from "../modules/auth";
import { AuthenticatedResponse } from "../shared/models/AuthenticatedResponse";
import { MsalUserProfile } from "../shared/models/MsalUserProfile";
import { SessionUser } from "../shared/models/sessionUser";
import { LocalStorageService } from "./local-storage.service";
import { Reseller } from "../models/Reseller/Reseller";

@Injectable({
	providedIn: "root",
})
export class TokenStorageService {
	private currentUser: SessionUser;
	private TOKEN_KEY = "auth-token";
	private USER_KEY = "auth-user";
	private COMPANY_KEY = "auth-company"; //emisor id
	private SUBSIDIARY_KEY = "auth-subsidiary"; // sucursal id
	private USER_NAME_KEY = "auth-username";
	private USER_FIRST_NAME_KEY = "auth-firstname";
	private USER_LAST_NAME_KEY = "auth-lastname";
	private USER_MSAL_KEY = "msal-user";
	private MSAL_SESSION_ACTIVE = "msal-active";
	private USER_HAS_RESELLER = "auth-has-reseller";
	private RESELLER = "auth-reseller";
	private COMPANY_RUT = "auth-company-rut";
	private CERTIFICADO_RUT = "auth-certificado-rut";
	private CERTIFICADO_NOMBRE = "auth-certificado-nombre";
	// private USER_RESELLER_ID = "auth-reseller-id";
	// private USER_RESELLER_FONO = "auth-reseller-fono";
	// private USER_RESELLER_LOGO = "auth-reseller-logo";

	userIsLogged = new EventEmitter<boolean>();
	currentUser$: Observable<UserModel>;
	currentUserSubject: BehaviorSubject<UserModel> = new BehaviorSubject<UserModel>(undefined);
	public currentEmisorObservable: Observable<string>;
	currentEmisorSubject: BehaviorSubject<string> = new BehaviorSubject<string>("");
	msalUser$: Observable<MsalUserProfile>;
	profile: MsalUserProfile;
	msalUserSubject: BehaviorSubject<MsalUserProfile> = new BehaviorSubject<MsalUserProfile>(undefined);
	private loggedLocal: boolean = false;
	private loggedMsal: boolean = false;
	private sucursalHasChangedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	public sucursalHasChangedObservable: Observable<boolean>;
	get currentUserValue(): UserModel {
		return this.currentUserSubject.value;
	}

	set currentUserValue(user: UserModel) {
		this.currentUserSubject.next(user);
	}
	//private TOKEN_EXPIRATION = 'auth-exp';
	currentEmisorIdEmitter = new EventEmitter<string>();

	constructor(private localStorage: LocalStorageService, private http: HttpClient, private msalService: MsalService) {
		//this.currentUserSubject = ;
		this.currentUser$ = this.currentUserSubject.asObservable();
		this.msalUser$ = this.msalUserSubject.asObservable();
		this.currentEmisorSubject = new BehaviorSubject<string>("");
		this.currentEmisorObservable = this.currentEmisorSubject.asObservable();
		this.sucursalHasChangedSubject = new BehaviorSubject<boolean>(false);
		this.sucursalHasChangedObservable = this.sucursalHasChangedSubject.asObservable();
	}

	authContainer = window.sessionStorage;

	signOut(): void {
		this.authContainer.clear();
	}
	public syncUserSessionFromLocalStorage() {
		const localUserSession = this.localStorage.getUserSession();
		if (localUserSession) {
			this.authContainer.setItem("local-usuario-sesion", JSON.stringify(localUserSession));
		}
	}


	public saveToken(token: string, expiration?: string): void {
		this.authContainer.removeItem(this.TOKEN_KEY);
		//this.authContainer.removeItem(this.TOKEN_EXPIRATION);
		this.authContainer.setItem(this.TOKEN_KEY, token);
		//this.authContainer.setItem(this.TOKEN_EXPIRATION,expiration);
	}

	public getToken(): string | null {
		return this.authContainer.getItem(this.TOKEN_KEY);
	}

	// public getExpiration():string | null{
	//   return this.authContainer.getItem(this.TOKEN_EXPIRATION);
	// }

	public saveUserData(response: AuthenticatedResponse): void {
		this.authContainer.removeItem(this.USER_KEY);
		this.authContainer.removeItem(this.COMPANY_KEY);
		this.authContainer.removeItem(this.SUBSIDIARY_KEY);
		this.authContainer.removeItem(this.USER_NAME_KEY);
		this.authContainer.removeItem(this.USER_FIRST_NAME_KEY);
		this.authContainer.removeItem(this.USER_LAST_NAME_KEY);
		this.authContainer.removeItem(this.COMPANY_RUT);
		this.authContainer.removeItem(this.CERTIFICADO_RUT);
		this.authContainer.removeItem(this.CERTIFICADO_NOMBRE);
		this.currentUser = new SessionUser(response.id, response.firstName, response.lastName, response.identifiers, response.temporaryPassword, response.superAdmin, response.configured, response.alertDemo, response.planes, response.email, response.cargo, response.isPartner, response.certificadoVigente, response.tieneEmpresasInactivas, response.cantidadEmpresasActivas, response.cantidadEmpresasInactivas, response.requiereRegularizacionAutomatica);
		const emisores = response.emisores || [];
		const empresa = emisores.find(e => e.activo && e.actual)
			|| emisores.find(e => e.activo)
			|| emisores.find(e => e.actual)
			|| emisores[0];
		const sucursal = (response.sucursales || []).find(s => s.emisorId === empresa?.emisorId && s.activa);
		if (empresa) {
			this.authContainer.setItem(this.COMPANY_KEY, empresa.emisorId);
			this.authContainer.setItem(this.COMPANY_RUT, empresa.rut.toString());
		}
		this.authContainer.setItem(this.CERTIFICADO_RUT, response.certificadoRut);
		this.authContainer.setItem(this.CERTIFICADO_NOMBRE, response.certificadoNombre || "");
		if (sucursal) this.authContainer.setItem(this.SUBSIDIARY_KEY, sucursal.sucursalId);
		this.authContainer.setItem(this.USER_KEY, JSON.stringify(this.currentUser));
		this.authContainer.setItem(this.USER_NAME_KEY, response.firstName + " " + response.lastName);
		this.authContainer.setItem(this.USER_FIRST_NAME_KEY, response.firstName);
		this.authContainer.setItem(this.USER_LAST_NAME_KEY, response.lastName);
		let userFullName = new UserModel();
		userFullName.fullname = response.firstName + " " + response.lastName;
		userFullName.firstname = response.firstName;
		userFullName.lastname = response.lastName;
		this.currentUserSubject = new BehaviorSubject<UserModel>(userFullName);
	}

	public getUser(): any {
		const user = this.authContainer.getItem(this.USER_KEY);
		if (user) {
			return JSON.parse(user);
		}
		return {};
	}

	public getCompany() {
		const companyId = this.authContainer.getItem(this.COMPANY_KEY);
		this.currentEmisorIdEmitter.emit(companyId);
		return companyId;
	}

	public getSubsidiary() {
		return this.authContainer.getItem(this.SUBSIDIARY_KEY);
	}

	public getUserName() {
		return this.authContainer.getItem(this.USER_NAME_KEY);
	}

	public getUserFirstName() {
		return this.authContainer.getItem(this.USER_FIRST_NAME_KEY);
	}
	public getUserLastName() {
		return this.authContainer.getItem(this.USER_LAST_NAME_KEY);
	}

	public setCertificadoIsVigente(certificadoVigente: boolean) {
		if(this.currentUser == undefined){
			this.currentUser = this.getUser();
		}
		this.currentUser.certificadoVigente = certificadoVigente;
		this.authContainer.setItem(this.USER_KEY, JSON.stringify(this.currentUser));
	}

	public setCompany(newCompanyId: string) {
		this.authContainer.removeItem(this.COMPANY_KEY);
		this.authContainer.setItem(this.COMPANY_KEY, newCompanyId);
		this.currentEmisorIdEmitter.emit(newCompanyId);
		this.currentEmisorSubject.next(newCompanyId);
		this.setSubsidiaryFromCompany(newCompanyId);
	}
	public setCompanyRut(rut: number) {
		this.authContainer.removeItem(this.COMPANY_RUT);
		this.authContainer.setItem(this.COMPANY_RUT, rut.toString());
	}
	private setSubsidiaryFromCompany(companyId: string) {
		const subsidiarySource = JSON.parse(this.localStorage.getSucursales()) as Sucursal[];
		let newSubsidiaryOfCompany = subsidiarySource.find((subsidiary) => subsidiary.emisorId == companyId);
		if (newSubsidiaryOfCompany) {
			this.authContainer.removeItem(this.SUBSIDIARY_KEY);
			this.authContainer.setItem(this.SUBSIDIARY_KEY, newSubsidiaryOfCompany.sucursalId);
		}
	}

	public setSubsidiaryDirectly(sucursalId: string) {
		this.authContainer.removeItem(this.SUBSIDIARY_KEY);
		this.authContainer.setItem(this.SUBSIDIARY_KEY, sucursalId);
	}

	public getSubsidiaryFromCompany(companyId: string) {
		const subsidiarySource = JSON.parse(this.localStorage.getSucursales()) as Sucursal[];
		let newSubsidiaryOfCompany = subsidiarySource.find((subsidiary) => subsidiary.emisorId == companyId);
		return newSubsidiaryOfCompany.sucursalId;
	}

	updateOwnSucursal(suc: Sucursal) {
		let subsidiarySource = JSON.parse(this.localStorage.getSucursales()) as Sucursal[];
		let subsidiaryIncluded: Sucursal = subsidiarySource.find((s) => s.sucursalId == suc.sucursalId);
		if (subsidiaryIncluded) {
			let index = subsidiarySource.indexOf(subsidiaryIncluded);
			subsidiarySource[index] = suc;
			this.localStorage.saveSucursales(subsidiarySource);
			this.sucursalHasChangedSubject.next(true);
		}
	}

	setMsalUser() {
		this.http.get(environment.msal_graph_endpoint).subscribe((profile) => {
			this.profile = profile as MsalUserProfile;
			this.authContainer.setItem(this.USER_MSAL_KEY, JSON.stringify(this.profile));
			this.msalUserSubject.next(this.profile);
		});
	}

	public getMsalUser() {
		let user = this.authContainer.getItem(this.USER_MSAL_KEY);
		this.msalUserSubject.next(JSON.parse(user) as MsalUserProfile);
		this.loggedMsal = true;
		return user;
	}

	msalLogin() {
		this.msalService.loginRedirect({
			scopes: ["user.read"],
		});
	}

	msalLogout() {
		this.msalService.instance.logoutRedirect({
			postLogoutRedirectUri: environment.msal_postlogout_redirect_uri,
		});
		this.loggedMsal = false;
	}

	msalUserIsLogged() {
		let estaLogeado = JSON.parse(this.authContainer.getItem(this.MSAL_SESSION_ACTIVE));
		this.loggedMsal = estaLogeado;
		return this.loggedMsal;
	}

	msalUserHasLogged() {
		this.loggedMsal = true;
		this.authContainer.removeItem(this.MSAL_SESSION_ACTIVE);
		this.authContainer.setItem(this.MSAL_SESSION_ACTIVE, JSON.stringify(this.loggedMsal));
	}

	updateAmbientOfCompany(emisorId: string, ambiente: number) {
		let emisorReturned = this.localStorage.updateAmbienteOfEmisor(emisorId, ambiente);
		if (emisorReturned == this.getCompany()) {
			this.currentEmisorSubject.next(this.getCompany());
		}
	}

	public saveResellerData(hasReseller: boolean, reseller: Reseller) {
		this.authContainer.removeItem(this.USER_HAS_RESELLER);
		this.authContainer.removeItem(this.RESELLER);

		this.authContainer.setItem(this.USER_HAS_RESELLER, JSON.stringify(hasReseller));
		this.authContainer.setItem(this.RESELLER, JSON.stringify(reseller));
	}

	public getReseller(): Reseller {
		return JSON.parse(this.authContainer.getItem(this.RESELLER)) as Reseller;
	}

	public userHasReseller(): boolean {
		return JSON.parse(this.authContainer.getItem(this.USER_HAS_RESELLER)) as boolean;
	}
	public getCompanyRut(): number {
		var rut = Number(this.authContainer.getItem(this.COMPANY_RUT));
		return rut;
	}

	public getCertificadoRut(): string {
		return this.authContainer.getItem(this.CERTIFICADO_RUT) || '';
	}

	public setCertificadoRut(certificadoRut: string): void {
		this.authContainer.setItem(this.CERTIFICADO_RUT, certificadoRut);
	}

	public getCertificadoNombre(): string {
		return this.authContainer.getItem(this.CERTIFICADO_NOMBRE) || "";
	}

	public setCertificadoNombre(certificadoNombre: string): void {
		this.authContainer.setItem(this.CERTIFICADO_NOMBRE, certificadoNombre || "");
	}
}
